export interface ReleaseNotesStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

interface ReleaseNotesPreference {
  lastSeenRelease?: unknown;
}

export const RELEASE_NOTES_STORAGE_PREFIX = 'nexus_release_notes';

export function getReleaseNotesStorageKey(uid: string): string {
  return `${RELEASE_NOTES_STORAGE_PREFIX}:${encodeURIComponent(uid)}`;
}

function getBrowserStorage(): ReleaseNotesStorage | null {
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readLastSeenRelease(
  uid: string,
  storage: ReleaseNotesStorage | null = getBrowserStorage()
): string | null {
  if (!uid || !storage) return null;

  try {
    const raw = storage.getItem(getReleaseNotesStorageKey(uid));
    if (!raw) return null;
    const preference = JSON.parse(raw) as ReleaseNotesPreference;
    return typeof preference.lastSeenRelease === 'string' ? preference.lastSeenRelease : null;
  } catch {
    return null;
  }
}

export function saveLastSeenRelease(
  uid: string,
  version: string,
  storage: ReleaseNotesStorage | null = getBrowserStorage()
): boolean {
  if (!uid || !version || !storage) return false;

  try {
    storage.setItem(
      getReleaseNotesStorageKey(uid),
      JSON.stringify({ lastSeenRelease: version })
    );
    return true;
  } catch {
    return false;
  }
}
